import React, { useContext } from "react";
import { Link as ReactLink } from 'react-router-dom';
import { Tr, Td, Link, Text, Flex } from "@chakra-ui/react";

import { getLatestObservation, getStationName, getObservationInPreferredUnits, getParameterUnit } from "../../utils/helpers";
import { PreferredUnitsContext } from "../../components/contexts/PreferredUnitsContext";
import { CardinalDirectionIndicator } from "../../components/CardinalDirectionIndicator";

export const StationRow = (props) => {
    const { station, datasetsMetadata, parameter } = props;

    const [preferredUnitSystem] = useContext(PreferredUnitsContext);

    if (!station || !datasetsMetadata) {
        return null;
    }

    const stationMetadata = datasetsMetadata.find((metadata) => metadata?.datasetID === station?.datasetID)?.metadata;
    const stationObservations = station.obsData;

    if (!stationMetadata) {
        console.log(`no metadata found for station ${station?.datasetID}`);
        return null;
    }

    const stationName = getStationName(stationMetadata);
    const latestObservation = getLatestObservation(stationObservations, parameter);
    const selectedParamLatestObservation = latestObservation?.[parameter]
    const canonicalUnit = getParameterUnit(stationMetadata, parameter);
    const convertedObservation = getObservationInPreferredUnits(parameter, latestObservation?.[parameter], canonicalUnit, preferredUnitSystem);
    const isDirection = parameter.includes('direction');

    // if the station doesn't have an observation on the selected parameter, don't show it
    if (!convertedObservation?.value) {
        return null;
    };

    return (
        <Tr>
            <Td display={'flex'} justifyContent={'space-between'} style={{ textWrap: 'wrap' }} px={0}>
                <Link textColor={'teal.700'} as={ReactLink} to={`/stations/${station?.datasetID}/${parameter}`} fontSize='md'>
                    {stationName}
                </Link>
                <Flex>
                    <Text fontWeight={'bold'}>
                        {convertedObservation?.value}
                        {convertedObservation?.unit}
                    </Text>
                    {isDirection &&
                        <CardinalDirectionIndicator parameter={parameter} degrees={selectedParamLatestObservation} directionSize={13} arrowSize={20} />
                    }
                </Flex>
            </Td>
        </Tr>
    );
};
